import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5632cba2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5632cba2')) {
      api.createRecord('5632cba2', component.options)
    } else {
      api.reload('5632cba2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5632cba2&", function () {
      api.rerender('5632cba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Screenfull/index.vue"
export default component.exports